/* app/js/src/components/tenant/choose-template/choose-template.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
.choose-template {
  overflow-y: auto;
}
.choose-template .header {
  height: 100px;
  text-align: center;
  margin-top: 60px;
  margin-bottom: 8px;
}
.choose-template .header h1 {
  font-size: 36px;
  font-weight: 300;
  color: #232f3a;
}
.choose-template main {
  display: flex;
}
.choose-template main side-menu {
  width: 300px;
}
.choose-template .create-channel-overlay {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  background-color: black;
  opacity: 0.6;
}
.choose-template .preloader {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
}
.choose-template .preloader .msg {
  width: 137px;
  height: 13px;
  font-size: 24px;
  font-family: "Open Sans";
  line-height: 2.31;
  color: white;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  position: relative;
  left: 5px;
}
/*# sourceMappingURL=choose-template.component.css.map */
